import React, { useState, useEffect } from 'react';
import AdminBookingDetailsModal from './AdminBookingDetailsModal';
import { api } from '../../lib/api';
import './AdminBookings.css';

const AdminBookingsList = () => {
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedBooking, setSelectedBooking] = useState(null);

    // Filters
    const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
    const [endDate, setEndDate] = useState(new Date(Date.now() + 86400000).toISOString().split('T')[0]); // Tomorrow
    const [statusFilter, setStatusFilter] = useState("ALL");

    const fetchBookings = async () => {
        setLoading(true);
        try {
            const query = new URLSearchParams({
                start_date: startDate,
                end_date: endDate,
                status: statusFilter
            });

            const res = await api.get(`/api/admin/bookings?${query}`);

            if (!res.ok) throw new Error("Failed to fetch bookings");

            const data = await res.json();
            setBookings(data);
        } catch (err) {
            console.error(err);
            alert("Error fetching bookings");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBookings();
    }, [startDate, endDate, statusFilter]);

    return (
        <div className="admin-bookings-page">
            <div className="page-header">
                <h2>Global Booking Management</h2>
                <div className="filters-bar">
                    <div className="filter-group">
                        <label>From:</label>
                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                    </div>
                    <div className="filter-group">
                        <label>To:</label>
                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </div>
                    <div className="filter-group">
                        <label>Status:</label>
                        <select
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                        >
                            <option value="ALL">ALL</option>
                            <option value="PENDING_APPROVAL">Pending Approval</option>
                            <option value="CONFIRMED">Confirmed</option>
                            <option value="COMPLETED">Completed</option>
                            <option value="CANCELLED">Cancelled</option>
                        </select>
                    </div>
                    <button className="refresh-btn" onClick={fetchBookings}>🔄 Refresh</button>
                </div>
            </div>

            <div className="bookings-table-container">
                {loading ? (
                    <div className="loading-spinner">Loading schedule...</div>
                ) : bookings.length === 0 ? (
                    <div className="empty-state">No bookings found for selected range/status.</div>
                ) : (
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th>Date & Time</th>
                                <th>Status</th>
                                <th>Customer</th>
                                <th>Artisan</th>
                                <th>Package</th>
                                <th>Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            {bookings.map((b) => (
                                <tr key={b.booking_id}>
                                    <td>
                                        <div className="datetime-cell">
                                            <span className="date">{b.date}</span>
                                            <span className="time">{b.start_time}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <span className={`status-badge status-${b.status.toLowerCase()}`}>
                                            {b.status.replace('_', ' ')}
                                        </span>
                                    </td>
                                    <td>
                                        <div className="user-cell">
                                            <span className="name">{b.customer.name}</span>
                                            <span className="email sub-text">{b.customer.email}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="user-cell">
                                            <span className="name">{b.artisan.name}</span>
                                            <span className="email sub-text">{b.artisan.email}</span>
                                        </div>
                                    </td>
                                    <td>{b.package_name}</td>
                                    <td>
                                        <button
                                            className="btn-view"
                                            onClick={() => setSelectedBooking(b)}
                                        >
                                            View Details
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            {selectedBooking && (
                <AdminBookingDetailsModal
                    booking={selectedBooking}
                    onClose={() => setSelectedBooking(null)}
                    onRefresh={fetchBookings}
                />
            )}
        </div>
    );
};

export default AdminBookingsList;
